import axios from "axios";


axios.interceptors.request.use((config) => {
  const tokenData = localStorage.getItem('token');
  config.headers["Authorization"] = `Bearer ${tokenData}`;
  return config;
});

export const request = {
  get: axios.get,
};

export const requestPost = {
  post: axios.post,
};

export const requestPatch = {
  patch: axios.patch,
};
